import type { TtsRegion } from "@unbox/api";

const getAffiliateHost = (region: TtsRegion | undefined): string => {
  switch (region) {
    case "US":
      return "https://affiliate-us.tiktok.com";
    default:
      return "https://affiliate.tiktok.com";
  }
};

/**
 * Builds the TikTok Shop collaboration detail URL.
 *
 * @param collaborationId - The collaboration ID (invitation_id in TikTok's system)
 * @param region - The TTS region (e.g., "US", "GB")
 * @returns The full URL to the collaboration detail page on TikTok Shop
 */
export const buildTikTokCollaborationUrl = (collaborationId: string, region: TtsRegion | undefined): string => {
  return `${getAffiliateHost(region)}/connection/target-invitation/detail?invitation_id=${collaborationId}`;
};

/**
 * Builds the TikTok Shop target collaboration setup URL.
 */
export const buildTikTokTargetCollaborationSetupUrl = (region: TtsRegion | undefined): string => {
  return `${getAffiliateHost(region)}/connection/target-invitation`;
};

/**
 * Builds the TikTok Shop open collaboration setup URL.
 */
export const buildTikTokOpenCollaborationSetupUrl = (region: TtsRegion | undefined): string => {
  return `${getAffiliateHost(region)}/product/open-collaboration`;
};
